//import * as _hm from './_hf';
import * as _ht from './_ht';

export const vdd = (uz: _ht.uz, pz?: {
  bVsn?: _ht.b, 
  bDmn?: _ht.b, 
  bDlt?: _ht.b
}) => { // version, domain, delete : common condition
  let _cdn = '';
  if (pz?.bDlt ?? true) _cdn += (_cdn == '' ? ' ' : ' AND ') + `COALESCE(_dlt,-1) <> 1`
  if (pz?.bDmn ?? true) _cdn += (_cdn == '' ? ' ' : ' AND ') + `_dmn = ${uz._dmn}`
  if (pz?.bVsn ?? true) _cdn += (_cdn == '' ? ' ' : ' AND ') + `_vsn = _ltt`;
  //hf.l(`cmFTH 29: ${_cdn}`);
  return _cdn;
};
